var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.843,
    height: 24.721,
    viewBox: "0 0 28.843 24.721",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#e17739;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-38.218 -51.75)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M61.814,62.326a9,9,0,0,0,.1-1.305,9.27,9.27,0,0,0-18.541,0,8.985,8.985,0,0,0,.1,1.305A7.209,7.209,0,0,0,45.43,76.471H59.851a7.209,7.209,0,0,0,1.963-14.146ZM59.851,74.411H45.43a5.148,5.148,0,0,1-.624-10.259,1.029,1.029,0,0,0,.9-1.145,1.01,1.01,0,0,0-.027-.14,7.21,7.21,0,1,1,13.924,0,1.03,1.03,0,0,0,.872,1.286,5.148,5.148,0,0,1-.624,10.259Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M238.685,196.415l-1.155,1.155v-7.637a1.03,1.03,0,1,0-2.06,0v7.637l-1.155-1.155a1.03,1.03,0,0,0-1.482,1.431l.025.025,2.914,2.914a1.03,1.03,0,0,0,1.456,0h0l2.914-2.914a1.03,1.03,0,1,0-1.431-1.482l-.025.025Z",
    transform: "translate(-183.859 -129.766)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.0e0f1e2a444272279bbef91de06e4a0d.svg";
export { ForwardRef as ReactComponent };